import AttachFile from '@mui/icons-material/AttachFile';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function AttachFileIcon(props: FixMe) {
  return <AttachFile {...props} />;
}

export default AttachFileIcon;
